import { Logo } from "@/components/Logo"

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      {/* Art side */}
      <aside
        className="relative overflow-hidden hidden md:flex flex-col justify-between text-[var(--primary-foreground)] p-12"
        style={{
          background: "linear-gradient(160deg, #1B1612, #2A1D10)",
        }}
      >
        {/* hops texture */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "repeating-radial-gradient(circle at 20% 20%, rgba(255,255,255,0.03) 0 2px, transparent 2px 7px)",
          }}
        />
        <div className="relative flex items-center gap-3">
          <Logo variant="light" size={40} />
          <div className="leading-none">
            <div className="font-display font-semibold text-[17px] tracking-tight">BierTrack</div>
            <div className="font-mono text-[10px] mt-[3px] uppercase opacity-70 tracking-[0.18em]">Asset Tracker</div>
          </div>
        </div>

        <div className="relative">
          <div className="font-mono text-[11px] tracking-[0.18em] uppercase opacity-70 mb-4">
            — Asset tracking for breweries
          </div>
          <h2 className="font-display font-bold text-4xl lg:text-5xl leading-[1.05] tracking-tight m-0">
            Cada barril,<br />cada cliente,<br />cada movimento.
          </h2>
          <p className="mt-4 text-[15px] opacity-80 max-w-md leading-relaxed">
            Controle seu estoque de barris, cilindros e equipamentos — do galpão até a adega do cliente.
          </p>
        </div>

        <div className="relative flex gap-8 font-mono text-[10px] tracking-[0.18em] opacity-60 uppercase">
          <span>Brasil</span>
        </div>
      </aside>

      {/* Form side */}
      <section
        className="flex flex-col justify-center p-8 md:p-12"
        style={{ background: "var(--card)" }}
      >
        <div className="w-full max-w-sm mx-auto">{children}</div>
      </section>
    </div>
  )
}
